import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center space-x-0.5"
}
const _hoisted_2 = { class: "font-medium" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"25px !important"},
  class: "material-icons-outlined -mb-0.5"
}, " fullscreen ", -1)
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "flex items-center mb-3" }
const _hoisted_6 = { class: "my-auto cursor-default chip chip-sm" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "my-auto cursor-default chip chip-sm" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "relative overflow-y-hidden h-14" }
const _hoisted_11 = { class: "flex items-center mt-auto ml-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons" }, " edit ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"25px !important"},
  class: "material-icons-outlined -mb-0.5"
}, " fullscreen ", -1)
const _hoisted_14 = {
  key: 2,
  class: ""
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, " done ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, " done ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_MultiIcon = _resolveComponent("MultiIcon")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_FadedEdgesScrollableFragment = _resolveComponent("FadedEdgesScrollableFragment")!
  const _component_ProcessedTextFragment = _resolveComponent("ProcessedTextFragment")!
  const _component_FullExercise = _resolveComponent("FullExercise")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.reduced)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.previewTitle), 1),
          (_ctx.previewable)
            ? (_openBlock(), _createBlock(_component_Btn, {
                key: 0,
                variant: 'icon',
                outline: true,
                tooltip: _ctx.$t('misc.preview'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPreview = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex flex-col h-full card card-border", {
				'card-hoverable hover:border-transparent hover-shadow-elevation': _ctx.hoverable,
				'outline-success outline-4 border-transparent': _ctx.highlighted,
				'bg-gray-50 opacity-60': _ctx.selectionDisabled,
			}])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", {
                class: _normalizeClass(["mr-4", {
							'text-muted font-semibold': _ctx.exercise.label?.length === 0,
						}])
              }, _toDisplayString(_ctx.previewTitle), 3),
              _createVNode(_component_Tooltip, {
                noArrow: true,
                placement: 'bottom',
                textValue: _ctx.$t('exercise_states.' + _ctx.exercise.state)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_MultiIcon, {
                        class: "-ml-1",
                        icons: _ctx.exerciseStateIcons
                      }, null, 8, ["icons"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["textValue"]),
              _createVNode(_component_Tooltip, {
                noArrow: true,
                placement: 'bottom',
                textValue: _ctx.$t('exercise_types.' + _ctx.exercise.exercise_type)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_MultiIcon, {
                        class: _normalizeClass(["-ml-1", {
										'-ml-1.5  mt-1': _ctx.exercise.exercise_type === _ctx.ExerciseType.JS,
									}]),
                        icons: _ctx.exerciseTypeIcons
                      }, null, 8, ["class", "icons"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["textValue"])
            ]),
            _createVNode(_component_FadedEdgesScrollableFragment, {
              class: "flex mb-2",
              id: _ctx.tagsDivId,
              style: _normalizeStyle(_ctx.tagsDivStyle)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, index) => {
                  return (_openBlock(), _createBlock(_component_Tag, {
                    class: _normalizeClass(["mr-1", { 'z-10': index === _ctx.tags.length - 1 }]),
                    key: _ctx.elementId + '-tag-' + index,
                    tag: tag,
                    small: true
                  }, null, 8, ["class", "tag"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["id", "style"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ProcessedTextFragment, {
              style: {"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden"},
              class: "w-full overflow-x-hidden overflow-ellipsis text-muted",
              value: _ctx.previewText
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.showEdit)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 0,
                  onClick: _ctx.emitEdit,
                  variant: 'icon',
                  outline: true,
                  class: "icon-btn-primary",
                  tooltip: _ctx.$t('misc.edit')
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["onClick", "tooltip"]))
              : _createCommentVNode("", true),
            (_ctx.previewable)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 1,
                  class: "ml-auto",
                  variant: 'icon',
                  outline: true,
                  tooltip: _ctx.$t('misc.preview'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPreview = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["tooltip"]))
              : _createCommentVNode("", true),
            (_ctx.selectable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  ((_ctx.selectButtonTitle?.length ?? 0) === 0)
                    ? (_openBlock(), _createBlock(_component_Btn, {
                        key: 0,
                        variant: 'icon',
                        outline: true,
                        tooltip: _ctx.$t('misc.select'),
                        forceActive: _ctx.highlighted,
                        disabled: _ctx.selectionDisabled,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelection())),
                        class: _normalizeClass({ 'icon-btn-success': _ctx.highlighted })
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["tooltip", "forceActive", "disabled", "class"]))
                    : (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 1,
                        textValue: _ctx.selectButtonTitle,
                        placement: 'bottom'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Btn, {
                            variant: 'icon',
                            outline: true,
                            forceActive: _ctx.highlighted,
                            disabled: _ctx.selectionDisabled,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSelection()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }, 8, ["forceActive", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["textValue"]))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showPreview,
      onYes: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPreview = false)),
      confirmOnly: true,
      fullWidth: true,
      dismissible: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("misc.exercise_preview_title")), 1)
      ]),
      body: _withCtx(() => [
        _createVNode(_component_FullExercise, {
          exercise: _ctx.exercise,
          showTags: false
        }, null, 8, ["exercise"])
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}